var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-11{fill:red;}.cls-22{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu_home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M149.39,65.87a3.29,3.29,0,0,1-4.45.69L75.44,15.68,75,15.34,5.05,66.56a3.05,3.05,0,0,1-2.36.57A3.09,3.09,0,0,1,.62,65.87a3.17,3.17,0,0,1,.68-4.44L73.12,8.84a3.16,3.16,0,0,1,3.76,0l71.81,52.59A3.11,3.11,0,0,1,150,63.51,3.2,3.2,0,0,1,149.39,65.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M133.29,72v66.6a3.19,3.19,0,0,1-3.17,3.19H90.74a3.21,3.21,0,0,1-3.16-3c0-.07,0-.14,0-.23V100.45a12.57,12.57,0,0,0-25.14,0v38.14c0,.1,0,.17,0,.26a3.2,3.2,0,0,1-3.17,2.93H19.89a3.19,3.19,0,0,1-3.19-3.19V72a3.18,3.18,0,0,1,6.36,0v63.43h33v-35a18.93,18.93,0,0,1,37.86,0v35h33V72a3.18,3.18,0,0,1,6.36,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    width: 150,
    height: 150
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHome);
export default __webpack_public_path__ + "static/media/menu_home.a61678f8.svg";
export { ForwardRef as ReactComponent };